import { useGyldendalClickstream } from "./impl.click-stream";
import { useHotjar } from "./impl.hotjar";
import { useSleeknote } from "./impl.sleeknote";

/**
 * setup tracking scripts once the application has been hydrated and
 * bootstrapping is already in progress.
 */
export function useTracking(): void {
  useGyldendalClickstream();
  useHotjar();
  useSleeknote();
}
